import React from 'react';

export function BackToAppsSvg() {
  return (
    <svg
      width="8"
      height="15"
      viewBox="0 0 8 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.38888L3.02703 7.49999L8 12.6111L6.48649 14.1667L0 7.49999L6.48649 0.833324L8 2.38888Z"
        fill="#007CBE"
      />
    </svg>
  );
}
